<div
  *ngIf="contentSocialIcons && contentSocialIcons.length > 0"
  [ngClass]="{
    'border-0 p-0 mr-0':
      contentFooter && !contentFooter.countryLanguage && !contentFooter.feedback
  }"
  class="social-icons-container"
>
  <a
    (click)="open(item, item?.openExternalLinkModal)"
    *ngFor="let item of contentSocialIcons; let i = index"
    [attr.tabindex]="avoidFocus ? -1 : 0"
    [ngClass]="{ 'mr-0': i === contentSocialIcons?.length - 1 }"
    aria-haspopup="true"
    class="facebook circle-outline picturefill-background"
    href="javascript:void(0);"
    id="footer-{{ item.iconAlt | lowercase }}"
  >
    <img [attr.alt]="item.iconAlt" [src]="item.iconLogo" />
  </a>
</div>
